import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getLanguageNativeOptions, getLangaugeNativeLabel } from '../../util/data';
import { getIcon, getCountryIcon } from '../../util/icons';

import {
  activateLocalization,
} from '../../actions';

import {
  organizationId
} from '../../util';

class ChangeLocalizationModal extends Component{

  state = {
    selectedLocalization: null
  }

  componentDidUpdate(prevProps, prevState){
  if(!prevProps.visible && this.props.visible){
    //when showing...

    if(this.props.activeLocalizationKey){
      //if localization active, set to selectedLocalization in state
      this.setState({
        selectedLocalization: this.props.activeLocalizationKey
      });
    }
    else if(!this.state.selectedLocalization){
      //set to en by deafult if no selected localization
      this.setState({
        selectedLocalization: 'en'
      });
    }
  }
}

  changeLocalization(){

    const { activeLocalizationKey } = this.props;
    const { selectedLocalization } = this.state;

    this.props.activateLocalization(selectedLocalization, organizationId(), true, () => {
      this.props.hide();
    });
  }

  toggleLocalization(localizationKey){
    const localizationIsActive = this.state.selectedLocalization === localizationKey;

    if(!localizationIsActive){
      this.setState({
        selectedLocalization: localizationKey
      });
    }
    else{
      this.setState({
        selectedLocalization: null
      });
    }
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const { selectedLocalization } = this.state;
    const {
      activeLocalizationKey,
      fetchingLocalization,
      userHasPreferredLanguage,
      languages,
    } = this.props;

    let languageOptions = getLanguageNativeOptions();

    console.log('languages: ', languages);

    if(languages && languages.length > 0){
      languageOptions = _.filter(languageOptions, languageOption => {
        return languages.indexOf(languageOption.value) !== -1;
      });
    }

    return (
      <div className="modal change-localization">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            {userHasPreferredLanguage &&
              <div className="current-language">
                <div className="country-icon">{getCountryIcon(activeLocalizationKey)}</div>
                <div>{getLangaugeNativeLabel(activeLocalizationKey)}</div>
              </div>
            }
            <div className="message">Select a {userHasPreferredLanguage ? 'new' : ''} language below...</div>
            <div className={`language-options ${selectedLocalization ? 'has-selected' : ''}`}>
              {_.map(languageOptions, option => {
                const optionIsActive = this.state.selectedLocalization === option.value;

                return (
                  <div
                    onClick={() => { this.toggleLocalization(option.value); } }
                    key={`language-option-${option.value}`}
                    className={`language-option ${optionIsActive ? 'selected' : ''}`}><span className="country-icon">{getCountryIcon(option.value)}</span><span>{option.label}</span></div>
                )
              })}
            </div>
          </div>

          <div className="modal-actions">
            <button disabled={!selectedLocalization} onClick={this.changeLocalization.bind(this)} className={`button primary`}>{fetchingLocalization ? 'Fetching translations...' : (userHasPreferredLanguage ? 'Switch Language' : 'Select Language')}</button>
            <button disabled={fetchingLocalization} onClick={this.props.hide} className="button grey-outline">Cancel</button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    userHasPreferredLanguage: state.user && state.user.preferredLanguage,
    activeLocalizationKey: state.activeLocalization.data ? state.activeLocalization.data._id : 'en',
    fetchingLocalization: state.activeLocalization.loading
  }
}

export default connect(mapStateToProps, { activateLocalization })(ChangeLocalizationModal);



// WEBPACK FOOTER //
// ./src/components/modals/changeLocalization.js